const ASK_ROSIE_ROUTES: Array<{ pattern: RegExp; subject?: string }> = [
  { pattern: /^\/dashboard/ },
  { pattern: /^\/mobile-edit-account-nav/, subject: 'menu' },
  { pattern: /^\/account\/contact-info/, subject: 'email_phone' },
  { pattern: /^\/account\/basic-info/, subject: 'basic_info' },
  { pattern: /^\/account\/bank-info/, subject: 'payment_info' },
  { pattern: /^\/account\/driving-info\/vehicle-info/, subject: 'vehicle_info' },
  { pattern: /^\/account\/driving-info/, subject: 'driving_info' },
  { pattern: /^\/gig-history/, subject: 'gig_history' },
  { pattern: /^\/delivery\//, subject: 'gig_detail' },
  { pattern: /^\/tax-information/, subject: 'tax_info' },
  { pattern: /^\/seattle-dashboard/, subject: 'seattle_dashboard' },
  { pattern: /^\/account\/privacy-settings/, subject: 'privacy_settings' },
  { pattern: /^\/account\/language-preference/, subject: 'language_preference' },
  { pattern: /^\/account\/delete/, subject: 'delete_account' },
]

export function getOriginPage(pathname: string): string {
  return pathname.replace(/^\/webview(\/|$)/, '/') || '/'
}

function findAskRosieRoute(pathname: string) {
  const path = getOriginPage(pathname)
  return ASK_ROSIE_ROUTES.find(({ pattern }) => pattern.test(path))
}

export function shouldShowAskRosie(pathname: string): boolean {
  return findAskRosieRoute(pathname) !== undefined
}

export function getChatSubject(pathname: string): string | undefined {
  return findAskRosieRoute(pathname)?.subject
}
